import React, { useState, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import estilos from './TablaProducto.module.css';
import { v4 as uuidv4 } from 'uuid';
import Tooltip from '@mui/material/Tooltip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
} from "reactstrap";
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
function TablaProducto(props) {

    const { api = undefined } = props
    const marcas = props.marcas
    let fc_09ProductosMap = props.productosMap
    let otrainstalacion = props.propia
    const emicioncertificadopromocion = props.emicioncertificadopromocion
    const { handdleProducto, handdleRemoveProductosPrev, handdleEditProductosPrev, productos } = api
    const { inventario } = useSelector(state => state.inventarioInstalacion || {})
    const opcionesInventario = inventario?.todos || []
    const tieneInventario = opcionesInventario && opcionesInventario.length > 0
    const [loteInventario, setLoteInventario] = React.useState(null)
    const [errorVolumen, setErrorVolumen] = React.useState('')
    const maxLitros = loteInventario && loteInventario.litros !== undefined && loteInventario.litros !== null ? parseFloat(loteInventario.litros) : null
    const [id, setId] = React.useState()
    const [numerocertificado, setNumeroCertificado] = React.useState('')
    const [contenidoalcoholico, setContenidoAlcoholico] = React.useState('')
    const [volumen, setVolumen] = React.useState('')
    const [numeroanalisis, setNumeroAnalisis] = React.useState('')
    const [numerolote, setNumeroLote] = React.useState('')

    const [editar, setEditar] = React.useState(false)

    const [productoMap, setproductoMap] = React.useState()

    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    let columns = []
    if (otrainstalacion === true) {
        columns = [
            { field: 'numeroanalisis', headerName: 'Análisis de laboratorio', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: 1, },

            {
                field: 'numerolote', headerName: 'No. de lote', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: 1,
                renderCell: (params) =>
                (
                    <div>
                        <Tooltip title={`${params.row.numerolote}`} arrow>
                            <label>{`${params.row.numerolote} `}</label>
                        </Tooltip>
                    </div>
                )
            },
            {
                field: 'numerocertificado', headerName: 'No. de certificado', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: 1,
                renderCell: (params) =>
                (
                    <div>
                        <Tooltip title={`${params.row.numerocertificado}`} arrow>
                            <label>{`${params.row.numerocertificado} `}</label>
                        </Tooltip>
                    </div>
                )
            },
            { field: 'volumen', headerName: 'Volumen (Litros)', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: 1, },
            {
                field: 'contenidoalcoholico', headerName: '% Alc. Vol.', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: 1,
                renderCell: (params) =>
                (
                    <div>
                        <Tooltip title={`${params.row.contenidoalcoholico}`} arrow>
                            <label>{`${params.row.contenidoalcoholico} `}</label>
                        </Tooltip>
                    </div>
                )
            },
            {
                field: 'accion', headerName: 'Acción', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: 1,
                renderCell: (params) => (

                    <Fragment>
                        {fc_09ProductosMap?.length > 0 ? (
                            <Fragment>

                                {/* // <button className={'btn btn-warning ms-0'} onClick={() => { botonEditar(params) }}>Editar</button> */}
                                <button className={'btn btn-danger ms-1'} onClick={() => { botonCorregir(params) }} >Corregir</button>
                            </Fragment>
                        ) : (
                            <Fragment>
                                <button className={'btn btn-warning ms-0'} onClick={() => { botonEditar(params) }}>Editar</button>
                                <button className={'btn btn-danger ms-1'} onClick={() => { botonEliminar(params) }} >Eliminar</button>
                            </Fragment>)}
                    </Fragment>

                )
            },
        ]
    } else {
        columns = [
            { field: 'numeroanalisis', headerName: 'Análisis de laboratorio', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: 1, },
            {
                field: 'numerolote', headerName: 'No. de lote', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: 1,
                renderCell: (params) =>
                (
                    <div>
                        <Tooltip title={`${params.row.numerolote}`} arrow>
                            <label>{`${params.row.numerolote} `}</label>
                        </Tooltip>
                    </div>
                )
            },
            { field: 'volumen', headerName: 'Volumen (Litros)', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: 1, },
            {
                field: 'contenidoalcoholico', headerName: '% Alc. Vol.', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: 1,
                renderCell: (params) =>
                (
                    <div>
                        <Tooltip title={`${params.row.contenidoalcoholico}`} arrow>
                            <label>{`${params.row.contenidoalcoholico} `}</label>
                        </Tooltip>
                    </div>
                )
            },
            {
                field: 'numerocertificado', headerName: 'No. de certificado', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: 1,
                renderCell: (params) =>
                (
                    <div>
                        <Tooltip title={`${params.row.numerocertificado}`} arrow>
                            <label>{`${params.row.numerocertificado} `}</label>
                        </Tooltip>
                    </div>
                )
            },
            {
                field: 'accion', headerName: 'Acción', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: 1,
                renderCell: (params) => (

                    <Fragment>
                        {fc_09ProductosMap?.length > 0 ? (
                            <Fragment>

                                {/* // <button className={'btn btn-warning ms-0'} onClick={() => { botonEditar(params) }}>Editar</button> */}
                                <button className={'btn btn-danger ms-1'} onClick={() => { botonCorregir(params) }} >Corregir</button>
                            </Fragment>
                        ) : (
                            <Fragment>
                                <button className={'btn btn-warning ms-0'} onClick={() => { botonEditar(params) }}>Editar</button>
                                <button className={'btn btn-danger ms-1'} onClick={() => { botonEliminar(params) }} >Eliminar</button>
                            </Fragment>)}
                    </Fragment>

                )
            },
        ]
    }

    const botonEliminar = async (params) => {
        handdleRemoveProductosPrev({ data: params.row })
    }

    const botonGuardar = async () => {
        if (tieneInventario && !loteInventario) {
            settexto(`Debe seleccionar un lote de la lista de inventario disponible.`)
            setvalidacion(true)
            return
        }
        if (maxLitros !== null && parseFloat(volumen) > maxLitros) {
            settexto(`El volumen ingresado (${volumen} L) supera la cantidad disponible en el inventario (${maxLitros} L).`)
            setvalidacion(true)
            return
        }
        let dato = {
            id: id, numerocertificado: numerocertificado, contenidoalcoholico: contenidoalcoholico, volumen: volumen,
            numeroanalisis: numeroanalisis, numerolote: numerolote
        }
        handdleEditProductosPrev(dato)
        setNumeroCertificado('')
        setContenidoAlcoholico('')
        setVolumen('')
        setNumeroAnalisis('')
        setNumeroLote('')
        setLoteInventario(null)
        setErrorVolumen('')
        setEditar(false)
        setproductoMap([])
    }
    const botonEditar = async (params) => {
        setId(params.row.id)
        setNumeroCertificado(params.row.numerocertificado)
        setContenidoAlcoholico(params.row.contenidoalcoholico)
        setVolumen(params.row.volumen)
        setNumeroAnalisis(params.row.numeroanalisis)
        setNumeroLote(params.row.numerolote)
        const match = opcionesInventario.find(opt => (opt.no_lote === params.row.numerolote || opt.no_tanque === params.row.numerolote))
        if (match) {
            setLoteInventario(match)
        } else {
            setLoteInventario(null)
        }
        setErrorVolumen('')
        setEditar(true)
    }

    let datos = []
    let [rows, setRows] = React.useState(productos)
    React.useEffect(() => {
        setRows(productos)
    }, [productos])

    const botonAgregar = async () => {
        if (tieneInventario && !loteInventario) {
            settexto(`Debe seleccionar un lote de la lista de inventario disponible.`)
            setvalidacion(true)
            return
        }
        if (maxLitros !== null && parseFloat(volumen) > maxLitros) {
            settexto(`El volumen ingresado (${volumen} L) supera la cantidad disponible en el inventario (${maxLitros} L).`)
            setvalidacion(true)
            return
        }
        if (otrainstalacion === true) {
            if (contenidoalcoholico.toString().length > 0 && numerolote.length > 0 && volumen.length > 0) {
                let dato = {
                    id: uuidv4(), numerocertificado: numerocertificado, contenidoalcoholico: contenidoalcoholico, volumen: volumen,
                    numeroanalisis: numeroanalisis, numerolote: numerolote
                }
                handdleProducto(dato)
                setNumeroCertificado('')
                setContenidoAlcoholico('')
                setVolumen('')
                setNumeroAnalisis('')
                setNumeroLote('')
                setLoteInventario(null)
                setErrorVolumen('')
            } else {
                setvalidacion(true)
            }
        } else {
            if (contenidoalcoholico.toString().length > 0 && parseFloat(contenidoalcoholico) > 34 && parseFloat(contenidoalcoholico) < 56 && numeroanalisis.length > 0 &&
                numerolote.length > 0) {
                let dato = {
                    id: uuidv4(), numerocertificado: numerocertificado, contenidoalcoholico: contenidoalcoholico, volumen: volumen,
                    numeroanalisis: numeroanalisis, numerolote: numerolote
                }
                handdleProducto(dato)
                setNumeroCertificado('')
                setContenidoAlcoholico('')
                setVolumen('')
                setNumeroAnalisis('')
                setNumeroLote('')
                setLoteInventario(null)
                setErrorVolumen('')
            } else {
                setvalidacion(true)
            }
        }

    }
    const botonCancelar = async () => {
        setproductoMap([])
        setNumeroCertificado('')
        setContenidoAlcoholico('')
        setVolumen('')
        setNumeroAnalisis('')
        setNumeroLote('')
        setLoteInventario(null)
        setErrorVolumen('')
        setEditar(false)
    }
    const botonCorregir = async (params) => {
        const filtro = fc_09ProductosMap.filter(anexo => anexo.idfc30_anexoproducto === params.row.idfc30_anexoproducto)
        setproductoMap(filtro[0])
        if (params.row.idfc30_anexoproducto) setId(params.row.idfc30_anexoproducto)
        else setId(params.row.idfc30_anexoproducto)
        setNumeroCertificado(params.row.numerocertificado)
        setContenidoAlcoholico(params.row.contenidoalcoholico)
        setVolumen(params.row.volumen)
        setNumeroAnalisis(params.row.numeroanalisis)
        setNumeroLote(params.row.numerolote)
        const match = opcionesInventario.find(opt => (opt.no_lote === params.row.numerolote || opt.no_tanque === params.row.numerolote))
        if (match) {
            setLoteInventario(match)
        } else {
            setLoteInventario(null)
        }
        setErrorVolumen('')
        setEditar(true)
    }

    return (
        <>
            <FormGroup>
                {otrainstalacion === true ?
                    <div className='row align-items-center'>
                        <div className='col-md-6'>
                            <div className="form-floating mb-3">
                                <input type="text" min='0' className={`form-control ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck
                                    ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Contenido neto x botella'
                                    value={numeroanalisis} onChange={e => setNumeroAnalisis(e.target.value)}
                                    onWheel={event => event.currentTarget.blur()}
                                />
                                <label htmlFor='floatingInput'>N° de análisis de laboratorio</label>
                                <span className='text-danger' style={{ textAlign: 'justify' }}>{'Si su lote cuenta con más un análisis FQ indicarlos separados por una coma, Ej. NNMZ-1234, NNMZ-5678 ó OTR-A001234, NNMZ-9874. '}</span>
                                {numeroanalisis.length <= 0 ? <>
                                    <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                                <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            {tieneInventario ? (
                                <div className="mb-3">
                                    <Autocomplete
                                        options={opcionesInventario}
                                        getOptionLabel={(option) => {
                                            if (!option) return ''
                                            if (typeof option === 'string') return option
                                            return option.no_lote || option.no_tanque || ''
                                        }}
                                        isOptionEqualToValue={(option, val) => {
                                            if (!val) return false
                                            if (typeof val === 'string') return (option.no_lote === val || option.no_tanque === val)
                                            return (option.idinventario && val.idinventario && option.idinventario === val.idinventario) || (option.no_lote === val.no_lote)
                                        }}
                                        value={loteInventario}
                                        onChange={(event, newValue) => {
                                            if (newValue && typeof newValue === 'object') {
                                                const loteNum = newValue.no_lote || newValue.no_tanque || ''
                                                setNumeroLote(loteNum)
                                                setLoteInventario(newValue)
                                                if (newValue.clave_fq) {
                                                    setNumeroAnalisis(newValue.clave_fq)
                                                }
                                                if (newValue.porcentaje_alc_vol !== undefined && newValue.porcentaje_alc_vol !== null) {
                                                    setContenidoAlcoholico(String(newValue.porcentaje_alc_vol))
                                                }
                                                if (newValue.litros !== undefined && newValue.litros !== null) {
                                                    setVolumen(String(newValue.litros))
                                                }
                                                setErrorVolumen('')
                                            } else {
                                                setNumeroLote('')
                                                setLoteInventario(null)
                                                setErrorVolumen('')
                                            }
                                        }}
                                        renderOption={(props, option) => (
                                            <li {...props} key={option.idinventario || option.no_lote || Math.random()}>
                                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                    <strong>Lote: {option.no_lote || option.no_tanque || 'S/N'} ({option.tipo_inventario ? option.tipo_inventario.toUpperCase() : 'INVENTARIO'})</strong>
                                                    <small style={{ color: '#666', fontSize: '0.75rem' }}>
                                                        FQ: {option.clave_fq || 'N/A'} | %Alc: {option.porcentaje_alc_vol || 'N/A'}% | Litros: {option.litros || 0}L
                                                    </small>
                                                </div>
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Seleccionar lote del inventario"
                                                variant="outlined"
                                                placeholder="Seleccione un lote..."
                                                size="small"
                                                fullWidth
                                                className={productoMap?.productocheck !== undefined ? (productoMap?.productocheck ? 'inputDenegado' : 'inputValidado') : ''}
                                            />
                                        )}
                                    />
                                    {!loteInventario && (
                                        <span className='text-danger'>Debe seleccionar un lote del inventario</span>
                                    )}
                                    <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                                </div>
                            ) : (
                                <div className="form-floating mb-3">
                                    <input
                                        type="text"
                                        className={`form-control ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck ? 'inputDenegado' : 'inputValidado') : ''}`}
                                        id="floatingInputLote"
                                        placeholder="No. de lote"
                                        value={numerolote}
                                        onChange={e => {
                                            setNumeroLote(e.target.value)
                                            setLoteInventario(null)
                                        }}
                                    />
                                    <label htmlFor="floatingInputLote">No. de lote</label>
                                    {numerolote.length <= 0 && (
                                        <span className='text-danger'>Campo obligatorio</span>
                                    )}
                                    <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                                </div>
                            )}
                        </div>
                        <div className='col-md-4'>
                            <div className="form-floating mb-2">
                                <input type="text" className={`form-control ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck
                                    ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='No. de certificado NOM'
                                    value={numerocertificado} onChange={e => setNumeroCertificado(e.target.value)}
                                />
                                <label htmlFor='floatingInput'>No. de certificado</label>
                                <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className="form-floating mb-3">
                                <input type="number" min='0' max={maxLitros !== null ? maxLitros : undefined} className={`form-control ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck
                                    ? 'inputDenegado' : 'inputValidado') : ('')} ${errorVolumen ? 'is-invalid' : ''}`} id="floatingInput" placeholder='Volumen (Litros)'
                                    value={volumen} onChange={e => {
                                        const val = e.target.value;
                                        setVolumen(val);
                                        if (maxLitros !== null && parseFloat(val) > maxLitros) {
                                            setErrorVolumen(`El volumen no puede ser mayor a los ${maxLitros} L disponibles en el inventario`);
                                        } else {
                                            setErrorVolumen('');
                                        }
                                    }}
                                />
                                <label htmlFor='floatingInput'>Volumen (Litros)</label>
                                {maxLitros !== null && (
                                    <small className="text-muted">Disponible en inventario: {maxLitros} L</small>
                                )}
                                {errorVolumen && (
                                    <div className="text-danger" style={{ fontSize: '0.85rem' }}>{errorVolumen}</div>
                                )}
                                {volumen.length <= 0 && (
                                    <span className='text-danger'>Campo obligatorio</span>
                                )}
                                <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className="form-floating mb-2">
                                <input type="text" min='0' disabled={!!loteInventario} className={`form-control ${productoMap?.productocheck !== undefined ? (
                                    productoMap?.productocheck ? 'inputDenegado' : 'inputValidado') : ('')} `}
                                    id="floatingInput" placeholder='Contenido Alcohólico'
                                    value={contenidoalcoholico} onChange={e => {
                                        const inputValue = e.target.value;
                                        if (/^\d*\.?\d*$/.test(inputValue)) {
                                            setContenidoAlcoholico(inputValue);
                                        }
                                    }}
                                    onWheel={event => event.currentTarget.blur()}
                                />
                                <Tooltip title={`Contenido Alcohólico (% Alc. Vol.)`} arrow>
                                    <label htmlFor='floatingInput'>Contenido alcohólico (% Alc. Vol.)</label>
                                </Tooltip>
                                {loteInventario && (
                                    <small className="text-muted">Bloqueado según registro del lote en inventario</small>
                                )}
                            </div>
                            {contenidoalcoholico < 35 || contenidoalcoholico > 55 ?
                                <span className='text-danger'>El rango debe de ser de 35% a 55%</span> : ''
                            }<br />
                            {contenidoalcoholico.length <= 0 ? <>
                                <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                            <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                        </div>
                    </div>
                    :
                    <div className='row align-items-center'>
                        <div className='col-md-6'>
                            <div className="form-floating mb-3">
                                <input type="text" min='0' className={`form-control ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck
                                    ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Contenido neto x botella'
                                    value={numeroanalisis} onChange={e => setNumeroAnalisis(e.target.value)}
                                    onWheel={event => event.currentTarget.blur()}
                                />
                                <label htmlFor='floatingInput'>N° de análisis de laboratorio</label>
                                <span className='text-danger' style={{ textAlign: 'justify' }}>{'Si su lote cuenta con más un análisis FQ indicarlos separados por una coma, Ej. NNMZ-1234, NNMZ-5678 ó OTR-A001234, NNMZ-9874. '}</span>
                                {numeroanalisis.length <= 0 ? <>
                                    <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                                <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            {tieneInventario ? (
                                <div className="mb-3">
                                    <Autocomplete
                                        options={opcionesInventario}
                                        getOptionLabel={(option) => {
                                            if (!option) return ''
                                            if (typeof option === 'string') return option
                                            return option.no_lote || option.no_tanque || ''
                                        }}
                                        isOptionEqualToValue={(option, val) => {
                                            if (!val) return false
                                            if (typeof val === 'string') return (option.no_lote === val || option.no_tanque === val)
                                            return (option.idinventario && val.idinventario && option.idinventario === val.idinventario) || (option.no_lote === val.no_lote)
                                        }}
                                        value={loteInventario}
                                        onChange={(event, newValue) => {
                                            if (newValue && typeof newValue === 'object') {
                                                const loteNum = newValue.no_lote || newValue.no_tanque || ''
                                                setNumeroLote(loteNum)
                                                setLoteInventario(newValue)
                                                if (newValue.clave_fq) {
                                                    setNumeroAnalisis(newValue.clave_fq)
                                                }
                                                if (newValue.porcentaje_alc_vol !== undefined && newValue.porcentaje_alc_vol !== null) {
                                                    setContenidoAlcoholico(String(newValue.porcentaje_alc_vol))
                                                }
                                                if (newValue.litros !== undefined && newValue.litros !== null) {
                                                    setVolumen(String(newValue.litros))
                                                }
                                                setErrorVolumen('')
                                            } else {
                                                setNumeroLote('')
                                                setLoteInventario(null)
                                                setErrorVolumen('')
                                            }
                                        }}
                                        renderOption={(props, option) => (
                                            <li {...props} key={option.idinventario || option.no_lote || Math.random()}>
                                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                    <strong>Lote: {option.no_lote || option.no_tanque || 'S/N'} ({option.tipo_inventario ? option.tipo_inventario.toUpperCase() : 'INVENTARIO'})</strong>
                                                    <small style={{ color: '#666', fontSize: '0.75rem' }}>
                                                        FQ: {option.clave_fq || 'N/A'} | %Alc: {option.porcentaje_alc_vol || 'N/A'}% | Litros: {option.litros || 0}L
                                                    </small>
                                                </div>
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Seleccionar lote del inventario"
                                                variant="outlined"
                                                placeholder="Seleccione un lote..."
                                                size="small"
                                                fullWidth
                                                className={productoMap?.productocheck !== undefined ? (productoMap?.productocheck ? 'inputDenegado' : 'inputValidado') : ''}
                                            />
                                        )}
                                    />
                                    {!loteInventario && (
                                        <span className='text-danger'>Debe seleccionar un lote del inventario</span>
                                    )}
                                    <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                                </div>
                            ) : (
                                <div className="form-floating mb-3">
                                    <input
                                        type="text"
                                        className={`form-control ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck ? 'inputDenegado' : 'inputValidado') : ''}`}
                                        id="floatingInputLote"
                                        placeholder="No. de lote"
                                        value={numerolote}
                                        onChange={e => {
                                            setNumeroLote(e.target.value)
                                            setLoteInventario(null)
                                        }}
                                    />
                                    <label htmlFor="floatingInputLote">No. de lote</label>
                                    {numerolote.length <= 0 && (
                                        <span className='text-danger'>Campo obligatorio</span>
                                    )}
                                    <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                                </div>
                            )}
                        </div>
                        <div className='col-md-4'>
                            <div className="form-floating mb-3">
                                <input type="number" min='0' max={maxLitros !== null ? maxLitros : undefined} className={`form-control ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck
                                    ? 'inputDenegado' : 'inputValidado') : ('')} ${errorVolumen ? 'is-invalid' : ''}`} id="floatingInput" placeholder='volumen'
                                    value={volumen} onChange={e => {
                                        const val = e.target.value;
                                        setVolumen(val);
                                        if (maxLitros !== null && parseFloat(val) > maxLitros) {
                                            setErrorVolumen(`El volumen no puede ser mayor a los ${maxLitros} L disponibles en el inventario`);
                                        } else {
                                            setErrorVolumen('');
                                        }
                                    }}
                                />
                                <label htmlFor='floatingInput'>Volumen (Litros)</label>
                                {maxLitros !== null && (
                                    <small className="text-muted">Disponible en inventario: {maxLitros} L</small>
                                )}
                                {errorVolumen && (
                                    <div className="text-danger" style={{ fontSize: '0.85rem' }}>{errorVolumen}</div>
                                )}
                                {volumen.length <= 0 && (
                                    <span className='text-danger'>Campo obligatorio</span>
                                )}
                                <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                            </div>
                        </div>
                        <div className='col-md-4'><br />
                            <div className="form-floating mb-2">
                                <input type="text" min='0' disabled={!!loteInventario} className={`form-control ${productoMap?.productocheck !== undefined ? (
                                    productoMap?.productocheck ? 'inputDenegado' : 'inputValidado') : ('')} `}
                                    id="floatingInput" placeholder='Contenido Alcohólico'
                                    value={contenidoalcoholico} onChange={e => {
                                        const inputValue = e.target.value;
                                        if (/^\d*\.?\d*$/.test(inputValue)) {
                                            setContenidoAlcoholico(inputValue);
                                        }
                                    }}
                                    onWheel={event => event.currentTarget.blur()}
                                />
                                <Tooltip title={`Contenido Alcohólico (% Alc. Vol.)`} arrow>
                                    <label htmlFor='floatingInput'>Contenido alcohólico (% Alc. Vol.)</label>
                                </Tooltip>
                                {loteInventario && (
                                    <small className="text-muted">Bloqueado según registro del lote en inventario</small>
                                )}
                            </div>
                            {contenidoalcoholico < 35 || contenidoalcoholico > 55 ?
                                <span className='text-danger'>El rango debe de ser de 35% a 55%</span> : ''
                            }<br />
                            {contenidoalcoholico.length <= 0 ? <>
                                <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                            <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                        </div>
                        <div className='col-md-4'>
                            <div className="form-floating mb-2">
                                <input type="text" className={`form-control ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck
                                    ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='No. de certificado NOM'
                                    value={numerocertificado} onChange={e => setNumeroCertificado(e.target.value)}
                                />
                                <label htmlFor='floatingInput'>No. de certificado NOM vigente</label>
                                {numerocertificado.length <= 0 ? <>
                                    <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                                <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                            </div>
                        </div>
                    </div>}
            </FormGroup>
            {!editar ?
                <Fragment>
                    {fc_09ProductosMap?.length === 0 ? (
                        <Fragment>
                            <div className='col-md-3'></div>
                            <div className='text-center'>
                                <button className='btn btn-success col-md-3' onClick={botonAgregar}>Agregar producto</button>
                            </div>
                            <br />
                        </Fragment>) : ''}
                </Fragment>
                : (
                    <Fragment>
                        <div className='row'>
                            <div className='col-md-3'></div>
                            <button className={'btn btn-success col-md-3 ms-0'} onClick={botonGuardar}>Guardar producto</button>
                            <button className={'btn btn-dark col-md-3 ms-2'} onClick={botonCancelar}>Cancelar</button>
                        </div>
                        <br />
                    </Fragment>
                )}
            <br />
            <hr />
            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
            <div className='row justify-content-center'>
                <div className='col-12'>
                    <div style={{ height: (130 + (rows?.length * 50)), width: '100%', color: 'black' }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}

                            sx={{
                                boxShadow: 0,
                                color: 'black',
                                border: 0,
                                '& .MuiDataGrid-cell': {
                                    display: 'block',
                                    position: 'relative',
                                    textAlign: 'center',
                                },
                            }}
                        />
                    </div>
                </div>
            </div>

        </>
    )

}
export default TablaProducto